// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611031841/js/" + chunkId + "." + {"44":"4ac5e4d1","225":"a66f536b","481":"f3f67c8d","486":"854b6500","770":"88b00446"}[chunkId] + ".0.3632450833226768.chunk.js";
};